import axios from 'axios';
import { baseURL } from '../../../../config/Env';
import AsyncStorage from '@react-native-async-storage/async-storage';

const api = axios.create({
    baseURL
});

export const getAllFaixasCep = async (page = 1, limit = 10) => {
    const dsToken = await AsyncStorage.getItem('token');

    return api.get('gestao/faixas-cep', {
        headers: { authorization: dsToken },
        params: { page, limit }
    });
};

export const deleteFaixaCep = async (idFaixaCep) => {
    const dsToken = await AsyncStorage.getItem('token');

    return api.delete('gestao/faixas-cep', {
        headers: { authorization: dsToken },
        params: { id_loja_faixa_cep: idFaixaCep }
    });
};

export const addFaixaCep = async (data) => {
    const dsToken = await AsyncStorage.getItem('token');

    return api.post(
        'gestao/faixas-cep',
        {
            dsFaixaCep: data.dsFaixaCep,
            nrFaixaInicial: data.nrFaixaInicial,
            nrFaixaFinal: data.nrFaixaFinal
        },
        {
            headers: { authorization: dsToken }
        }
    );
};
